import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { IClose } from 'planoplan-ui-kit/core/icons/i-close';
import { Rhytm } from 'planoplan-ui-kit/core/helpers/rhytm';
import { pushDataLayer } from '@libs';
import { textSize, Points } from '@styles';
import { BANNERS, IS_CLIENT } from '@constants';
import { setHideBanner } from '@store/actions';
import { isHeaderBannerVisible } from './helpers';

export const HeaderBanner = () => {
  const { common = {}, showBanners = {} } = useSelector((state) => state);
  const { banner = {} } = common;
  const { link, description, color, backgroundColor } = banner;
  const dispatch = useDispatch();

  const [isShow, setIsShow] = React.useState(isHeaderBannerVisible(banner, showBanners));

  React.useEffect(() => {
    if (IS_CLIENT && isShow) {
      pushDataLayer({
        event: 'ga4_Event',
        evName: 'mainBanner',
        evParam1: 'view',
        evParam2: banner.name,
      });
    }
  }, [isShow, banner.name]);

  const onClose = (e) => {
    e.stopPropagation();
    pushDataLayer({
      event: 'ga4_Event',
      evName: 'mainBanner',
      evParam1: 'close',
      evParam2: banner.name,
    });
    setIsShow(false);
    dispatch(setHideBanner(BANNERS.HEADER, banner.id));
  };

  const onClick = () => {
    pushDataLayer({
      event: 'ga4_Event',
      evName: 'mainBanner',
      evParam1: 'click',
      evParam2: banner.name,
    });
  };

  return (
    <>
      {isShow && (
        <Container backgroundColor={backgroundColor} onClick={onClick}>
          <Wrapper>
            <Description href={link} color={color} target="_blank" dangerouslySetInnerHTML={{ __html: description }} />
            <Close onClick={onClose}>
              <IClose width="14px" height="14px" fill={color} />
            </Close>
          </Wrapper>
        </Container>
      )}
    </>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 40px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  ${Grid.suffix(3.5, 36)};
  ${Grid.prefix(2, 36)};
  max-width: 1440px;
  position: relative;
  margin: 0 auto;
  width: 100%;

  @media ${Points.tablet_portrait} {
    ${Grid.suffix(3, 36)};
  }

  @media ${Points.laptop} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Description = styled.a`
  ${Mixins.resetLink()};
  ${textSize('p2')};
  font-weight: normal;
  color: ${({ color }) => color};
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  @media ${Points.tablet_portrait} {
    justify-content: center;
  }
`;

const Close = styled.button`
  ${Mixins.resetButton()};
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(0);
  right: ${Rhytm.column(2, 36)};

  @media ${Points.laptop} {
    right: ${Rhytm.column(1, 36)};
  }
`;
